import cx from 'classnames';
import React from 'react';

class VideoPanel extends React.PureComponent {
  render() {
    const {video, onPlay} = this.props;
    const ready = !!video.ready_at;
    const sd = ready && !(video.aspect_ratio >= 1.7 || video.aspect_ratio < 1.0);
    const aspectClass = cx('post-content-edge-to-edge', 'AspectRatioBox', {
      'AspectRatioBox--ratio-16-9': !sd,
      'AspectRatioBox--ratio-4-3': sd,
    });
    if (!ready) {
      return (
        <div className={aspectClass}>
          <div className="AspectRatioBoxPlaceholder AspectRatioBoxPlaceholder--noBorder" style={{backgroundColor: '#777', color: '#ddd'}}>
            <a className="AspectRatioBoxPlaceholder-text text-center" style={{color: 'inherit'}} onClick={this.props.onClick}>
              <div style={{fontSize: '400%'}}>
                <span className="fa fa-clock-o" />
              </div>
              This video is being processed. Check back later, or click here to refresh the page.
            </a>
          </div>
        </div>
      );
    }
    return (
      <a className={aspectClass} onClick={this.props.onClick}>
        <div className="AspectRatioBoxViewport">
          <img className="AspectRatioBoxViewport-img" src={video._links.thumbnail.href} />
          <div className="AspectRatioBoxViewport-overlay2">
            <i className="fa fa-play-circle-o video-link-post-overlay"></i>
          </div>
        </div>
      </a>
    );
  }
}

export default VideoPanel;
